/**
 *
 */
function createAcceleratedAnimation() {
    return () => { };
}

export { createAcceleratedAnimation };
